import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { PortService, AirPortService, LclPortService, Port } from 'app/services';

declare var scrollIntoViewIfNeeded:any;

@Component({
  selector: 'mat-port-selector',
  templateUrl: 'mat-port-selector.html'
})

export class MatPortSelectorComponent {
  @Input() label;
  @Input() placeholder;
  @Input() borderClass;
  @Input() portCdInput;
  @Input() locationIdInput;
  //sea(null), air
  @Input() portType;
  @Input() position:string = 'normal';
  @Output() portSelectEe:EventEmitter<any> = new EventEmitter();

  portList;
  countryList;
  selectedCountry;
  selectedPort;
  portCd;
  showDropDown:boolean = false;
  showCountryList: boolean = false;
  showPortList:boolean = false;
  suggestList:Array<any> = [];
  focusedPortIndex:number = 0;
  countryPortList:Array<any> = [];

  portControl: FormControl = new FormControl();

  disabled:boolean = false;

  @ViewChild("inputText")
  inputText;

  @ViewChild("suggestListRef")
  suggestListElRef: ElementRef;

  constructor(
    private portService: PortService,
    private airportService: AirPortService,
    private lclPortService: LclPortService
  ) {}

  ngOnInit() {
    this.portCd = this.portCdInput;
    this.initPortList();
  }

  initPortList() {
    let emitter:EventEmitter<any>;
    
    if (this.portType === 'air') {
      this.portList = this.airportService.airports;
      emitter = this.airportService.airPortListEe;
    } else if (this.portType === 'lcl') {
      this.portList = this.lclPortService.ports;
      emitter = this.lclPortService.portListEe;
    } else {
      this.portList = this.portService.ports;
      emitter = this.portService.portListEe;
    }
    
    if (!this.portList || !this.portList.length || this.portList.length <=0) {
      emitter.subscribe(
        port => {
          this.portList = port;
          this.setPortList();
        }
      )
    } else {
      this.setPortList();
    }
  }

  setPortList() {
    const portList = this.portList;
    let countryList: any[] = _.map(_.uniqBy(portList, 'cntryCd'),
                (port: Port) => {return {'cntryCd': port.cntryCd, 'cntryNm': port.cntryNm};}
                );

    countryList = _.sortBy(countryList, (cntry) => {return cntry.cntryCd === 'KR' ? 'A' : cntry.cntryNm;} );
    let portCd = this.portCd;
    let port = null;
    let country = null;
    let locationId = this.locationIdInput;

    if (portCd) {
      port = _.find(portList, {portCd : portCd});
      if(port){
        country = {cntryCd: port.cntryCd, cntryNm: port.cntryNm};
        this.portControl.setValue(port.label, {emitEvent:   true});
      }
    }

    if(locationId) {
      port = _.find(portList, {locationId : locationId});
      if(port){
        country = {cntryCd: port.cntryCd, cntryNm: port.cntryNm};
        this.portControl.setValue(port.label, {emitEvent: true});
      }

    }

    this.portList = portList;
    this.countryList = countryList;
    this.selectedCountry = country;
    this.selectedPort = port;
  }

  clickOutside() {
    if (this.showDropDown || (this.suggestList && this.suggestList.length > 0)) {
      this.clearPort();
    } else {
      this.showDropDown =  false;
      this.showCountryList = false;
      this.showPortList =  false;
    }
  }
	

  clearPort() {
    this.showDropDown =  false;
    this.showCountryList = false;
    this.showPortList =  false;
    this.suggestList = [];
    this.selectedCountry =  null;
    this.selectedPort =  null;
		this.focusedPortIndex =  0;
		this.portControl.setValue('');
  }

  setPortByCd(portCd) {
    const portList = this.portList;
    let countryList = _.map(_.uniqBy(portList, 'cntryCd'),
                (port: Port) => {return {'cntryCd': port.cntryCd, 'cntryNm': port.cntryNm};}
                );
    let port = null;
    let country = null;

    if (portCd) {
      port = _.find(portList, {portCd : portCd});
      country = {cntryCd: port.cntryCd, cntryNm: port.cntryNm};
      if (port) this.portControl.setValue(port.label);
    }

    this.selectedCountry =  country;
    this.selectedPort = port;
  }

  getCountryByCd(countryCd) {
    let country = null;
    const countryList = this.countryList;
    for (let i = 0 ; i < countryList.length ; i++) {
      let c = countryList[i];
      if (c.cntryCd === countryCd) return c;
    }
    return country;
  }

  getPortByCd(portCd) {
    let port = null;
    const portList = this.portList;
    for (let i = 0 ; i < portList.length ; i++) {
      let p = portList[i];
      if (p.portCd === portCd) return p;
    }
    return port;
  }

  getPort() {
    return this.selectedPort;
  }

  handleSuggest(e) {
    const portList = this.portList;
    let value = e.target.value;
    const inputValue = _.toUpper(value.trim()).replace(/\s/g, '');
    const inputLength = inputValue.length;

    let filteredList = [];
    let codeList = [];
    
    if ((this.portType === 'air' && inputValue.length > 2) ||
        (this.portType !== 'air' && inputValue.length > 1)) {
      codeList = _.filter(
        portList,
        (port) => {
          return port.portCd === inputValue;
        }
      );
      filteredList = _.filter(portList,
                                (port) => {
                                  let portLabel = _.toUpper(port.label).replace(/\s/g, '');
                                  return port.portCd != inputValue && portLabel.indexOf(inputValue) >= 0;
                                }
                              );
      
      filteredList = _.sortBy(
        filteredList,
        (port) => {
          let portLabel = _.toUpper(port.label).replace(/:/g, 'AAAAAAAAAAA');
          return portLabel;
        }
      );
      filteredList = _.sortBy(
        filteredList,
        (port) => {
          let portLabel = _.toUpper(port.label).replace(/\s/g, '');
          return _.toUpper(portLabel).indexOf(inputValue);
        }
      );

      filteredList = codeList.concat(filteredList);
    }

    
    this.showDropDown = false;
    this.showCountryList = false;
    this.showPortList = false;
    this.suggestList = filteredList;
    this.selectedCountry = null;
    this.selectedPort = null;
    this.focusedPortIndex = 0;
  }

  handleSelectPort(port) {
    this.suggestList =  [];
    this.selectedPort =  port;
    this.selectedCountry = {cntryCd: port.cntryCd, cntryNm: port.cntryNm};
    this.portControl.setValue(port.label);
    this.inputText.checkValue();
    this.portSelectEe.emit(port);
  }

  closeAllDropDown() {
    this.suggestList =  [];
    this.showDropDown =  false;
    this.showCountryList = false;
    this.showPortList = false;
  }

  handleShowDropDown() {
    if(this.showDropDown) {
      this.showDropDown = false;
    } else {
      this.suggestList = [];
      this.showDropDown = true;
      this.showCountryList = false;
      this.showPortList = false;
    }
  }

  handleShowCountryList() {
    this.showCountryList = true;
    this.showPortList = false;
  }

  handleSelectCountry(e, country) {
    let countriesPorts = _.filter(this.portList, {'cntryCd': country.cntryCd});

    this.countryPortList = countriesPorts;
    this.showCountryList =  false;
    this.selectedCountry =  country;
    this.selectedPort = null;

    e.stopPropagation();
  }

  handleShowCountryPortList() {
    this.showCountryList = false;
    this.showPortList = true;
  }

  handleSelectCountryPort(e, port) {
    this.selectedPort = port;
    this.showPortList = false;
    this.showDropDown = false;
    
    this.portControl.setValue(port.label);
    this.handleSelectPort(port);
  }


  handleKeyDown(event) {
    if (event.keyCode !== 9 && event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40) return;
    
    let focusedPortIndex = this.focusedPortIndex;
    let suggestListDom = null;
    if(this.suggestListElRef) suggestListDom = this.suggestListElRef.nativeElement;
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

    let port = this.suggestList[this.focusedPortIndex];

		switch (event.keyCode) {
      case 9: //tab
        if (port) this.handleSelectPort(port);
        break;
			case 13: // enter
        if (port) this.handleSelectPort(port);
			  break;
			case 27: // escape
				this.closeAllDropDown();
			  break;
			case 38: // up
        focusedPortIndex--;
        if (focusedPortIndex < 0) focusedPortIndex = 0;
        if (focusedPortIndex != this.focusedPortIndex) this.focusedPortIndex = focusedPortIndex;
        suggestListItem[focusedPortIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedPortIndex++;
        if (focusedPortIndex > this.suggestList.length - 1) focusedPortIndex = this.suggestList.length - 1;
        if (focusedPortIndex != this.focusedPortIndex) this.focusedPortIndex = focusedPortIndex;
        suggestListItem[focusedPortIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }
    if(event.keyCode != 9) {
      event.preventDefault();
    }
  }
  

  changePortTypeTo(portType: string) {
    if (this.portType === portType) return;
    this.portType = portType;
    this.initPortList();
  }

}


// WEBPACK FOOTER //
// ./src/app/components/selector/mat-port-selector.ts